import React, { useEffect } from 'react';
const getDate = (date) => {
    let formattedDate;
    let dateObject = new Date(date);
    let options = {
        day: '2-digit',
        month: 'short',
        year: 'numeric'
    };
    if (navigator.userAgent.indexOf('iPhone') > -1) {
        dateObject = new Date(date.replace(/-/g, "/"));
    }
    formattedDate = dateObject.toLocaleDateString(navigator.language, options);
    formattedDate = formattedDate.replace(/ /g, '-').replace(/,/g, '');
    return formattedDate;
};
function getMonthDays(year, month) {
    const lastDay = new Date(year, month, 0);
    return lastDay.getDate();
}
function GraphDataTable({ type, simObj, setSimObj }) {
    let RevenueData;
    let InventoryData;
    switch (type) {
        case "monthly":

            RevenueData = simObj?.graphdata?.filter((data, index) => {
                if (data.statemonth === simObj.laststate.statemonth) {
                    return true;
                }
            });
            RevenueData = (RevenueData != undefined ? RevenueData : []).map((data) => {
                return {
                    x: data.stateday,
                    y: data.revenue,
                    revenue: data.revenue,
                    purchaseCost: data.dailyPurchaseCost,
                    holdingCost: data.dailyHoldingCost,
                    orderingCost: data.dailyorderingCost,
                    stockoutCost: data.dailyStockOutcost,
                    totalCost: data.totalCost,
                    demandCost: data.dailyDemand,
                    date: getDate(data.currentRampDate),
                    quantityordered: data.quantityordered,
                    shippingType: data.shippingType,
                    event: data.Event
                }
            });
            InventoryData = simObj?.graphdata?.filter((data, index) => {
                if (data?.statemonth === simObj?.laststate?.statemonth) {
                    return true;
                }
            });
            InventoryData = (InventoryData != undefined ? InventoryData : []).map((data) => {
                return {
                    x: data.stateday,
                    y: data.unitsLeft ? data.unitsLeft : 500,
                    date: getDate(data.currentRampDate),
                    demandCost: data.dailyDemand,
                    unitsLeft: data.unitsLeft,
                }
            });
            break;
        case "quarterly":
            RevenueData = simObj?.graphdata?.filter((data, index) => {
                if (data.statemonth >= simObj.laststate.statemonth - 2) {
                    return true;
                }
            });
            RevenueData = (RevenueData != undefined ? RevenueData : []).map((data) => {
                return {
                    x: ((data.statemonth - 1) + (data.stateday / getMonthDays(simObj.laststate.stateyear, data.statemonth))).toFixed(2),
                    y: data.revenue,
                    revenue: data.revenue,
                    purchaseCost: data.dailyPurchaseCost,
                    holdingCost: data.dailyHoldingCost,
                    orderingCost: data.dailyorderingCost,
                    stockoutCost: data.dailyStockOutcost,
                    totalCost: data.totalCost,
                    demandCost: data.demandCost,
                    date: getDate(data.currentRampDate),
                    quantityordered: data.quantityordered,
                    shippingType: data.shippingType,
                    event: data.Event
                }
            });
            InventoryData = simObj?.graphdata?.filter((data, index) => {
                if (data.statemonth >= simObj?.laststate?.statemonth - 2) {
                    return true;
                }
            });
            InventoryData = (InventoryData != undefined ? InventoryData : []).map((data) => {
                return {
                    x: (data.statemonth - 1) + (data.stateday / getMonthDays(simObj?.laststate?.stateyear, data.statemonth)),
                    y: data.unitsLeft ? data.unitsLeft : 500,
                    demandCost: data.dailyDemand,
                    unitsLeft: data.unitsLeft,
                    date: getDate(data.currentRampDate)
                }
            });
            break;
        case "yearly":
            RevenueData = simObj?.graphdata;
            RevenueData = (RevenueData != undefined ? RevenueData : []).map((data) => {
                return {
                    x: ((data.statemonth - 1) + (data.stateday / getMonthDays(simObj.laststate.stateyear, data.statemonth))).toFixed(2),
                    y: data.revenue,
                    revenue: data.revenue,
                    purchaseCost: data.dailyPurchaseCost,
                    holdingCost: data.dailyHoldingCost,
                    orderingCost: data.dailyorderingCost,
                    stockoutCost: data.dailyStockOutcost,
                    totalCost: data.totalCost,
                    demandCost: data.demandCost,
                    date: getDate(data.currentRampDate),
                    quantityordered: data.quantityordered,
                    shippingType: data.shippingType,
                    event: data.Event
                }
            });
            InventoryData = simObj?.graphdata;

            InventoryData = (InventoryData != undefined ? InventoryData : []).map((data) => {
                return {
                    x: (data?.statemonth - 1) + (data.stateday / getMonthDays(simObj?.laststate?.stateyear, data?.statemonth)),
                    y: data.unitsLeft ? data.unitsLeft : 500,
                    demandCost: data.dailyDemand,
                    unitsLeft: data.unitsLeft,
                    date: getDate(data.currentRampDate),
                }
            });
            break;
        default:
            RevenueData = [];
            break;
    }


    return (
        <div className="header-container">
            <header class="header main-header"><div class="container"><h1 class="title" aria-hidden="false" tabindex="-1">Inventory Management Simulation Graph Data as of  {getDate(simObj?.laststate?.currentRampDate)}</h1></div></header>
            <div className="MainDiv">
                <div className="MainDivChild">
                    <div class="jumbotron text-center bg-sky">
                        <h3 className="headingh3">Revenue/Cost Of Quality Graph Data</h3>
                    </div>

                    <div className="container">

                        <table id="RevenueGraphData" class="display cell-border">
                            <thead>
                                <tr>
                                    <th>Day</th>
                                    <th>Revenue</th>
                                    <th>Purchase Cost</th>
                                    <th>Holding Cost</th>
                                    <th>Ordering Cost</th>
                                    <th>Stockout Cost</th>
                                    <th>Total Cost</th>
                                    <th>Decision Taken</th>
                                    <th>Event Triggered</th>
                                </tr>
                            </thead>
                            <tbody>
                                {RevenueData.map((data, index) => (
                                    <tr key={index}>
                                        <td>{data.date}</td>
                                        <td>${data.revenue}</td>
                                        <td>${data.purchaseCost}</td>
                                        <td>${data.holdingCost}</td>
                                        <td>${data.orderingCost}</td>
                                        <td>${data.stockoutCost}</td>
                                        <td>${data.totalCost}</td>
                                        <td>{data.quantityordered > 0 ? `You placed a ${data.shippingType.replace("_", " ").toLowerCase()} order of ${data.quantityordered} units` : "None"}</td>
                                        <td>{data.event != null ? data.event : "None"}</td>

                                    </tr>
                                ))}
                            </tbody>

                        </table>


                    </div>
                    <p></p>
                    <div className="container">

                        <div class="jumbotron text-center bg-sky">
                            <h3 className="headingh3">Inventory Demand Graph Data</h3>
                        </div>
                        <table id="InventoryGraphData" class="display cell-border">
                            <thead>
                                <tr>
                                    <th>Day</th>
                                    <th>Units Left</th>
                                    <th>Demand</th>
                                </tr>
                            </thead>
                            <tbody>
                                {InventoryData.map((data, index) => (
                                    <tr key={index}>
                                        <td>{data.date}</td>
                                        <td>{data.unitsLeft}</td>
                                        <td>{data.demandCost}</td>
                                    </tr>
                                ))}
                            </tbody>

                        </table>

                    </div>
                </div>
            </div>
            <footer className="footer">
                <div className="container">

                    <span className="copyright-text">Copyright &#169;2023 </span>
                    <ul className="footer-links">
                        <li className="listitem"><a href="https://www.pearson.com/en-us.html" target='_blank'>Pearson Education</a></li>
                        <li className="listitem"><span>&nbsp;|&nbsp;</span></li>
                        <li className="listitem"><a href="https://loginstatic.pearson.com/html/PearsonPrivacyPolicy.html?" target='_blank'>Privacy Policy</a></li>
                    </ul>
                </div>

            </footer>

        </div>

    );
}

export default GraphDataTable;
